import {
  Button,
  Col,
  Drawer,
  Form,
  Icon,
  Input,
  notification,
  Popconfirm,
  Row,
  Select,
  Switch,
  Table,
  Tooltip,
  message,
  Modal,
  Alert,
} from "antd";
import { Component, Fragment } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Show from "../../../contexts/PermissionContext/Show";
import {
  ShowFeatureFlag,
  FEATURE_FLAGS,
} from "../../../contexts/PermissionContext";
import { validate as isValidEmail } from "email-validator";
import api from "../../../services/api";
import * as requests from "../../../requests/index";
import "./index.css";
import { BRAND as BRAND_ID } from "../../../config";
import { appEnv } from "../../../appEnv";
import { FreireContext } from "../../../utils/freireContext";
import * as texts from "../locales";
import { sorter } from "../../../utils/sorter";
import SelectCountry from "../../../components/SelectCountry";
import CountryFlag from "../../../components/SelectCountry/CountryFlag";
import stationReportImg from "../../../assets/img/stationReport.png";
import MonthlyCouponReport from "../../../assets/img/monthlyCouponReport.png";
import quotaReportImg from "../../../assets/img/quota-consumption-alert.png";
import SelectWithNewItem from "../../../components/SelectWithNewItem";
import AllowedAppsForm from "../AllowedAppsForm";
import {
  useWhitelabels,
  BRAND_WHITELABEL_ALIAS,
} from "../../../components/WhitelabelThemesProvider";
import withPermission from "../../../contexts/PermissionContext/withPermission";
import AlertParentCompanyIconPack from "../AlertParentCompanyIconPack";
import CompanyWebFlowBatch from "../../../components/CompanyWebFlowBatch";
import { getCompanyCurrentUser } from "../../../services/auth";
import { getCompanyCustomThemes } from "../../../services/companyCustomTheme";
import { getContaAzulAuthUrl } from "../../../services/nfe";
import { DOCUMENT_TYPES } from "../../../constants/document-types";
import {
  formatDocumentByType,
  validateDocumentByType,
} from "../../../utils/document-masks";
import {
  FISCAL_MODEL_OPTIONS,
  SOFTWARE_LICENSE,
} from "../../../constants/fiscal-models";
import copy from "copy-to-clipboard";

const { Option } = Select;

// TODO: Teste temporário, remover logo depois
const COMPANY_IDS_FOR_CONTA_AZUL_TEST = (
  appEnv.REACT_APP_COMPANY_IDS_FOR_CONTA_AZUL_TEST ?? ""
)
  .split(",")
  .filter(Boolean);

const NFE_PROVIDER = {
  CONTA_AZUL: "CONTA_AZUL",
  OMIE: "OMIE",
};

class ListCompanies extends Component {
  static contextType = FreireContext;

  state = {
    loadingTable: false,
    loadingFetchData: false,
    hasIconPack: false,
    countries: [],
    data: [],
    visible: false,
    company: {},
    admin: false,
    companys: [],
    recipients: [],
    recipient: {},
    dateFiltrada: [],
    tablePage: 1,
    emailSwitch: false,
    emails: [],
    inputEmail: "",
    showModal1: false,
    showModal2: false,
    showModal3: false,
    setEmails: [],
    loadingSave: false,
    setLoadingSave: false,
    customerTypes: [],
    customThemes: [],
    userCompany: null,
    hasParentCompanyPartner: false,
    // NFS-e state
    nfeProvider: "",
    nfeEnabled: false,
    nfeClientId: "",
    nfeClientSecret: "",
    nfeStep1Done: false,
    nfeIntegrationActive: false,
    nfeAuthLoading: false,
    nfeFinalizeLoading: false,
    nfeInfoModalVisible: false,
    // Draft companies
    onlyDrafts: false,
    loadingActivate: {},
  };
  showModal1 = () => {
    this.setState({ showModal1: true });
  };

  handleCancel1 = () => {
    this.setState({ showModal1: false });
  };

  showModal2 = () => {
    this.setState({ showModal2: true });
  };

  handleCancel2 = () => {
    this.setState({ showModal2: false });
  };

  showModal3 = () => {
    this.setState({ showModal3: true });
  };

  handleCancel3 = () => {
    this.setState({ showModal3: false });
  };

  componentDidMount() {
    this.getCompanys();
    this.fetchData();
  }

  fetchData = async () => {
    const { freire } = this.context;

    try {
      this.setState({ loadingFetchData: true });

      const [countries, customerTypes, customThemes] = await Promise.all([
        this.getCountries(),
        this.getCustomerTypes(),
        this.getCustomThemes(),
      ]);

      this.setState({
        countries,
        customerTypes,
        customThemes,
      });
    } catch (error) {
      notification.error({
        message: freire(texts.OOPS),
        description: error.message,
      });
    } finally {
      this.setState({ loadingFetchData: false });
    }
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.filter();
    }
  };

  save() {
    this.props.form.validateFields(async (err, values) => {
      if (err) return;

      const payload = { ...values };

      this.putCompany(payload);
    });
  }

  getCustomThemes = async () => {
    const { freire } = this.context;

    try {
      const themes = await getCompanyCustomThemes();
      return themes;
    } catch (error) {
      throw new Error(freire(texts.ERROR_LIST_CUSTOM_THEMES));
    }
  };

  getCustomerTypes = async () => {
    const { freire } = this.context;

    try {
      const {
        data: { customerTypes },
      } = await api.get("customer-types");
      return customerTypes;
    } catch (error) {
      throw new Error(freire(texts.ERROR_CUSTOMER_TYPE));
    }
  };

  onAddNewCustomerType = async (newCustomerType) => {
    this.setState((state) => ({
      customerTypes: [...state.customerTypes, { name: newCustomerType }],
      company: { ...state.company, customerType: newCustomerType },
    }));
  };

  getCompanys = async (params = {}) => {
    const { freire } = this.context;

    try {
      this.setState({ loadingTable: true });

      const { data: companiesData } = await api.get("company");
      const companies = sorter(companiesData, "companyName");

      const { data: recipients } = await api.get("recipient");

      const userCompany = await getCompanyCurrentUser();

      const isUserCompanyHolding = companies.find(
        (company) => company._id === userCompany?.id,
      )?.holding;

      this.setState({
        loadingTable: false,
        data: companies,
        dateFiltrada: companies,
        recipients,
        userCompany: { ...userCompany, holding: isUserCompanyHolding },
      });
    } catch (error) {
      notification.error({
        message: freire(texts.OOPS),
        description: freire(texts.ERROR_LIST_COMPANIES),
      });
    } finally {
      this.setState({ loadingTable: false });
    }
  };

  getCountries = async () => {
    const { freire } = this.context;

    try {
      const countries = await requests.getRecommendedCountries();
      return countries;
    } catch (error) {
      throw new Error(freire(texts.ERROR_LIST_COUNTRIES));
    }
  };

  openDrawer = async (company) => {
    const documentType = company?.document_type ?? DOCUMENT_TYPES.CNPJ;

    this.setState({
      visible: true,
      company: {
        ...company,
        document_type: documentType,
        document: formatDocumentByType(company?.document ?? "", documentType),
        cpms_custom_theme: company?.cpms_custom_theme ?? null,
      },
      hasParentCompanyPartner: company?.parent_company_partners?.length > 0,
      hasIconPack: company.iconPack !== undefined,
      emails: company.emails ?? [],
    });

    // Prime NFSe settings from current company doc
    const provider = company?.nfeProvider ?? "";
    const hasSavedContaAzulConfig = Boolean(
      provider === NFE_PROVIDER.CONTA_AZUL &&
      company?.integrations?.contaAzul?.clientId,
    );
    const isNfseActive =
      Boolean(provider) &&
      (provider !== NFE_PROVIDER.CONTA_AZUL || hasSavedContaAzulConfig);

    this.setState({
      nfeProvider: provider,
      nfeEnabled: Boolean(provider),
      // Prefill Conta Azul clientId if present; keep secret empty for security
      nfeClientId: company?.integrations?.contaAzul?.clientId || "",
      nfeClientSecret: "",
      nfeStep1Done: isNfseActive,
      nfeIntegrationActive: isNfseActive,
      nfeAuthLoading: false,
      nfeFinalizeLoading: false,
      nfeInfoModalVisible: false,
    });
  };

  closeDrawer = () => {
    this.props.form.resetFields();
    this.setState({
      visible: false,
      emails: [],
      company: {},
      hasParentCompanyPartner: false,
      nfeProvider: "",
      nfeEnabled: false,
      nfeClientId: "",
      nfeClientSecret: "",
      nfeStep1Done: false,
      nfeIntegrationActive: false,
      nfeAuthLoading: false,
      nfeFinalizeLoading: false,
      nfeInfoModalVisible: false,
    });
  };

  filter = () => {
    this.props.form.validateFields((err, values) => {
      if (err) return;

      const { companyName, country } = values;
      const source = this.state.data;

      const filteredCompanies = source.filter((company) => {
        const nameMatches =
          !companyName ||
          company.companyName.toLowerCase().includes(companyName.toLowerCase());

        const countryMatches = !country || company.country === country;

        return nameMatches && countryMatches;
      });

      const sortedCompanies = sorter(filteredCompanies, "companyName");

      this.setState({
        dateFiltrada: sortedCompanies,
        tablePage: 1,
      });
    });
  };

  clearFilters = () => {
    this.props.form.resetFields();
    this.setState((prev) => ({
      dateFiltrada: sorter(prev.data, "companyName"),
      onlyDrafts: false,
    }));
    this.getCompanys();
  };

  getDraftCompanies = async () => {
    const { freire } = this.context;
    try {
      this.setState({ loadingTable: true });
      const { data: companies } = await api.get("company", {
        params: { onlyDrafts: true },
      });
      const sorted = sorter(companies, "companyName");
      this.setState({ dateFiltrada: sorted });
    } catch (error) {
      notification.error({
        message: freire(texts.OOPS),
        description: freire(texts.ERROR_LIST_COMPANIES),
      });
    } finally {
      this.setState({ loadingTable: false });
    }
  };

  onToggleDrafts = (checked) => {
    this.setState({ onlyDrafts: checked, tablePage: 1 }, () => {
      if (checked) {
        this.getDraftCompanies();
      } else {
        this.getCompanys();
      }
    });
  };

  approveCompany = async (companyId) => {
    const { freire } = this.context;
    this.setState((prev) => ({
      loadingActivate: { ...prev.loadingActivate, [companyId]: true },
    }));
    try {
      await api.patch(`company/${companyId}/approve`);
      notification.success({ message: freire(texts.ACTIVATE_COMPANY_SUCCESS) });
      await this.getDraftCompanies();
    } catch (error) {
      notification.error({
        message: freire(texts.OOPS),
        description: error?.response?.data?.showError
          ? error.response.data.message
          : freire(texts.ERROR_ACTIVATE_COMPANY),
      });
    } finally {
      this.setState((prev) => {
        const loadingActivate = { ...prev.loadingActivate };
        delete loadingActivate[companyId];
        return { loadingActivate };
      });
    }
  };

  goNew = () => {
    this.props.history.push("/dashboard/new_company");
  };

  onSearch(val) {
    // console.log("search:", val);
  }

  onSelect = (val) => {
    var recipients = this.state.recipients;
    var recipient = recipients.find((element) => val === element._id);
    this.setState({ recipient: recipient });
  };

  focusNfseField = (fieldId) => {
    const element = document.getElementById(fieldId);
    if (element?.focus) element.focus();
  };

  onStartNfseAuthentication = () => {
    const { freire } = this.context;
    const clientId = (this.state.nfeClientId || "").trim();
    const clientSecret = (this.state.nfeClientSecret || "").trim();

    if (!clientId) {
      message.warning(freire(texts.NFSE_FILL_CLIENT_ID));
      this.focusNfseField("nfse-client-id");
      return;
    }

    if (!clientSecret) {
      message.warning(freire(texts.NFSE_FILL_CLIENT_SECRET));
      this.focusNfseField("nfse-client-secret");
      return;
    }

    this.setState({ nfeInfoModalVisible: true });
  };

  onContinueNfseAuthProcess = async () => {
    const { freire } = this.context;
    const { company, nfeClientId, nfeClientSecret, nfeProvider } = this.state;
    if (!company?._id) return;

    const clientId = (nfeClientId || "").trim();
    const clientSecret = (nfeClientSecret || "").trim();
    if (!clientId || !clientSecret) return;
    this.setState({ nfeAuthLoading: true });

    try {
      const authUrl = await getContaAzulAuthUrl({
        companyId: company._id,
        clientId,
        clientSecret,
        nfeProvider,
      });

      if (!authUrl) {
        notification.error({
          message: freire(texts.OOPS),
          description: freire(texts.ERROR_GENERATE_AUTH_LINK),
        });
        return;
      }

      window.open(authUrl, "_blank");

      this.setState({
        nfeInfoModalVisible: false,
        nfeAuthLoading: false,
        nfeStep1Done: true,
        nfeIntegrationActive: false,
      });
    } catch (error) {
      notification.error({
        message: freire(texts.OOPS),
        description: error?.message || freire(texts.ERROR_GENERATE_AUTH_LINK),
      });
      this.setState({ nfeAuthLoading: false });
    }
  };

  onUndoNfseStep1 = () => {
    this.setState({
      nfeStep1Done: false,
      nfeIntegrationActive: false,
      nfeClientId: "",
      nfeClientSecret: "",
    });
  };

  onRemoveNfseIntegration = () => {
    this.setState((prev) => ({
      nfeStep1Done: false,
      nfeIntegrationActive: false,
      nfeClientId: "",
      nfeClientSecret: "",
      company: {
        ...prev.company,
        nfeProvider: null,
      },
    }));
  };

  onFinalizeNfseIntegration = async () => {
    const { freire } = this.context;
    const { company, nfeProvider, nfeClientId, nfeClientSecret, nfeStep1Done } =
      this.state;

    if (!company?._id || !nfeStep1Done) return;

    const clientId = (nfeClientId || "").trim();
    const clientSecret = (nfeClientSecret || "").trim();
    const integrationPayload = {
      _id: company._id,
      nfeProvider: nfeProvider || null,
    };

    if (nfeProvider === NFE_PROVIDER.CONTA_AZUL) {
      const contaAzul = {};
      if (clientId) contaAzul.clientId = clientId;
      if (clientSecret) contaAzul.clientSecretEnc = clientSecret;
      if (Object.keys(contaAzul).length > 0) {
        integrationPayload.integrations = { contaAzul };
      }
    }

    try {
      this.setState({ nfeFinalizeLoading: true });
      await api.put("company", integrationPayload);

      this.setState((prev) => ({
        nfeIntegrationActive: true,
        company: {
          ...prev.company,
          nfeProvider: nfeProvider || null,
          integrations:
            nfeProvider === NFE_PROVIDER.CONTA_AZUL
              ? {
                  ...prev.company?.integrations,
                  contaAzul: {
                    ...prev.company?.integrations?.contaAzul,
                    ...(clientId ? { clientId } : {}),
                    ...(clientSecret ? { clientSecretEnc: clientSecret } : {}),
                  },
                }
              : prev.company?.integrations,
        },
      }));

      message.success(freire(texts.NFSE_INTEGRATION_COMPLETED));
    } catch (error) {
      notification.error({
        message: freire(texts.OOPS),
        description: error?.message || freire(texts.ERROR_GENERATE_AUTH_LINK),
      });
    } finally {
      this.setState({ nfeFinalizeLoading: false });
    }
  };

  addRecebedor = () => {
    var { company } = this.state;
    var recipient = this.state.recipient;
    recipient.percentage = 0;
    company.splitRule.push(recipient);
    this.setState({ company });
  };

  putCompany = async (extraInfo = null) => {
    const { freire } = this.context;
    const { company } = this.state;

    // Inclui campos NFSe no payload ao salvar
    const nfeExtra = {};
    nfeExtra.nfeProvider =
      this.state.nfeEnabled && this.state.nfeProvider
        ? this.state.nfeProvider
        : null;
    if (
      this.state.nfeEnabled &&
      this.state.nfeProvider === NFE_PROVIDER.CONTA_AZUL
    ) {
      const contaAzul = {};
      const cid = (this.state.nfeClientId || "").trim();
      const csec = (this.state.nfeClientSecret || "").trim();
      if (cid) contaAzul.clientId = cid;
      // Only send secret when user filled it; backend should keep old if absent
      if (csec) contaAzul.clientSecretEnc = csec;
      if (Object.keys(contaAzul).length > 0) {
        nfeExtra.integrations = { contaAzul };
      }
    }

    if (!company?.document_type) {
      message.error(
        `${freire(texts.SELECT_DOCUMENT_TYPE)} - ${freire(
          texts.REQUIRED_FIELD,
        )}`,
      );
      return;
    }

    const isDocumentOptional = company.document_type === DOCUMENT_TYPES.CUIT;
    const trimmedDocument = company.document?.trim();

    if (!isDocumentOptional && !trimmedDocument) {
      message.error(`Documento é um ${freire(texts.REQUIRED_FIELD)}`);
      return;
    }

    if (
      trimmedDocument &&
      !validateDocumentByType(trimmedDocument, company.document_type)
    ) {
      message.error(freire(texts.INVALID_DOCUMENT_FORMAT));
      return;
    }

    try {
      if (company.hasSplit) {
        const splitTotal = this.state.company.splitRule.reduce(
          (total, rule) => parseInt(total) + parseInt(rule.percentage),
          0,
        );
        if (splitTotal !== 100) {
          alert(freire(texts.TOTAL_NOT_FULL));
          return;
        }
      }
      await api.put(`company`, {
        ...(extraInfo || {}),
        ...nfeExtra,
        _id: company._id,
        parentCompanyID: company.parentCompanyID,
        document_type: company.document_type,
        document: trimmedDocument ?? null,
        companyName: company.companyName,
        pipedrive_id: company.pipedrive_id,
        hasSplit: company.hasSplit,
        splitRule: company.splitRule,
        iconPack: company.iconPack ?? null,
        cpms_custom_theme: company.cpms_custom_theme ?? null,
        whiteLabelAlias: company.whiteLabelAlias ?? null,
        powerbi: company.powerbi,
        emails: this.state.emails,
        customerType: company.customerType ?? null,
        ocpiPartyId: company.ocpiPartyId,
        parent_company_partners: company.parent_company_partners,
        fiscal_model: company.fiscal_model ?? null,
        idleFeeFirstForgivenessEnabled:
          company.idleFeeFirstForgivenessEnabled ?? false,
      });
      this.getCompanys();
      this.closeDrawer();
    } catch (err) {}
  };
  getColumnsSplit = () => {
    const { freire } = this.context;

    return [
      {
        title: freire(texts.RECIPIENT),
        dataIndex: "recipientName",
        key: "recipientName",
      },
      {
        title: freire(texts.PERCENTAGE),
        dataIndex: "percentage",
        key: "percentage",
        render: (value, row, index) => {
          return (
            <Input
              type="number"
              value={
                this.state.company
                  ? this.state.company.splitRule[index].percentage
                  : ""
              }
              maxLength={2}
              onChange={(e) => {
                var company = this.state.company;
                if (
                  this.state.company.splitRule.reduce(
                    (total, rule) =>
                      parseInt(total) + parseInt(rule.percentage),
                    0,
                  ) -
                    parseInt(this.state.company.splitRule[index].percentage) +
                    parseInt(e.target.value) <=
                    100 &&
                  e.target.value > 0
                ) {
                  company.splitRule[index].percentage = e.target.value;
                  this.setState({ company });
                }
              }}
            />
          );
        },
      },
      {
        title: freire(texts.LIABLE),
        dataIndex: "liable",
        key: "liable",
        render: (value, row, index) => {
          return (
            <Switch
              value={
                this.state.company
                  ? this.state.company.splitRule[index].liable
                  : false
              }
              onChange={(e) => {
                var company = this.state.company;
                company.splitRule[index].liable = e;
                this.setState({ company });
              }}
            />
          );
        },
      },
      {
        title: freire(texts.CHARGE_PROCESSING_FEE),
        dataIndex: "charge_processing_fee",
        key: "charge_processing_fee",
        render: (value, row, index) => {
          return (
            <Switch
              value={
                this.state.company
                  ? this.state.company.splitRule[index].charge_processing_fee
                  : false
              }
              onChange={(e) => {
                var company = this.state.company;
                company.splitRule[index].charge_processing_fee = e;
                this.setState({ company });
              }}
            />
          );
        },
      },
      {
        title: freire(texts.DELETE),
        key: "delet",
        render: (value, row, index) => {
          return (
            <Button
              onClick={() => {
                var company = this.state.company;
                company.splitRule.splice(index, 1);
                this.setState({ company });
              }}
            />
          );
        },
      },
    ];
  };

  getColumnsTable = () => {
    const { freire } = this.context;

    const renderCountry = (countryCode) => {
      const country = this.state.countries.find(
        (country) => country.code === countryCode,
      );

      return country ? <CountryFlag country={country} /> : "----";
    };

    const renderParentCompany = (parentCompanyID) => {
      return (
        this.state.data.find((company) => company._id === parentCompanyID)
          ?.companyName ?? "----"
      );
    };

    return [
      {
        title: freire(texts.NAME),
        dataIndex: "companyName",
        key: "companyName",
      },
      {
        title: freire(texts.COUNTRY),
        dataIndex: "country",
        key: "country",
        render: renderCountry,
      },
      {
        title: freire(texts.PARENT_COMPANY),
        dataIndex: "parentCompanyID",
        key: "parentCompanyID",
        render: renderParentCompany,
      },
      {
        title: freire(texts.ACTIONS),
        key: "acoes",
        width: "10%",
        render: (text, data) => (
          <Fragment>
            <Show when={"edit-company"}>
              <Tooltip placement="top" title={freire(texts.SHOW_DETAILS_EDIT)}>
                <Button
                  shape="circle"
                  size="small"
                  ghost
                  type="primary"
                  style={{ marginRight: 8 }}
                  onClick={() => this.openDrawer(data)}
                >
                  <Icon type="edit" />
                </Button>
              </Tooltip>
            </Show>
            {this.state.onlyDrafts && (
              <Show when={"view-draft-companies"}>
                <Popconfirm
                  placement="top"
                  title={freire(texts.ACTIVATE_COMPANY_CONFIRM)}
                  okText={freire(texts.YES)}
                  cancelText={freire(texts.NO)}
                  onConfirm={() => this.approveCompany(data._id)}
                >
                  <Tooltip
                    placement="top"
                    title={freire(texts.ACTIVATE_COMPANY)}
                  >
                    <Button
                      shape="circle"
                      size="small"
                      ghost
                      type="primary"
                      loading={!!this.state.loadingActivate[data._id]}
                    >
                      {!this.state.loadingActivate[data._id] && (
                        <Icon type="check" />
                      )}
                    </Button>
                  </Tooltip>
                </Popconfirm>
              </Show>
            )}
          </Fragment>
        ),
      },
    ];
  };

  onChangeParentCompany = (parentCompanyID) => {
    const parentCompany = this.state.data.find(
      (company) => company._id === parentCompanyID,
    );

    const hasIconPack = Boolean(parentCompany?.iconPack);

    this.setState(({ company }) => ({
      hasIconPack,
      company: {
        ...company,
        parentCompanyID,
        iconPack: hasIconPack ? parentCompany?.iconPack : undefined,
      },
    }));
  };

  onChangeHasIconPack = (hasIconPack) => {
    const parentCompany = this.state.data.find(
      (company) => company._id === this.state.company.parentCompanyID,
    );

    this.setState(({ company }) => ({
      hasIconPack,
      company: {
        ...company,
        iconPack: hasIconPack ? parentCompany?.iconPack : undefined,
      },
    }));
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      hasIconPack,
      loadingFetchData,
      countries,
      customerTypes,
      customThemes,
      company,
      loadingSave,
      hasParentCompanyPartner,
      userCompany,
    } = this.state;

    // TODO: Teste temporário, remover logo depois
    const showNfseProviderConfig =
      userCompany && COMPANY_IDS_FOR_CONTA_AZUL_TEST.includes(userCompany.id);

    const { loading, availableIconPacks, allWhitelabels, hasPermission } =
      this.props;
    const { freire } = this.context;
    const columns = this.getColumnsTable();
    const columnsSplit = this.getColumnsSplit();

    // Customization -------------------------------------------------------------
    const canSetHasCompanyPin = hasPermission("set-has-company-pin");
    const canEditCompanyPin = hasPermission("edit-company-pin");
    const canEditCompanyPowerBiUrl = hasPermission("edit-company-powerbi-url");
    const canEditCompanyWhiteLabel = hasPermission("edit-company-white-label");
    const canEditCompanyAllowedApps = hasPermission(
      "edit-company-allowed-apps",
    );
    const canEditCompanyCustomTheme = hasPermission(
      "edit-company-custom-theme",
    );
    // ---------------------------------------------------------------------------

    const whiteLabelsWithoutBrand = Object.values(allWhitelabels).filter(
      (whiteLabel) => whiteLabel.alias !== BRAND_WHITELABEL_ALIAS,
    );

    const parentCompany = this.state.data.find(
      (company) => company._id === this.state.company.parentCompanyID,
    );

    const parentCompanyIconPack = availableIconPacks.find(
      (iconPack) => iconPack.alias === parentCompany?.iconPack,
    );

    const companiesHolding = this.state.data.filter(
      (c) => c.holding && c._id !== company._id,
    );

    const isTupiUser =
      userCompany?.id === BRAND_ID && userCompany?.parentCompanyID === BRAND_ID;

    const isDocumentOptional = company?.document_type === DOCUMENT_TYPES.CUIT;
    const isContaAzulSelected =
      this.state.nfeEnabled &&
      this.state.nfeProvider === NFE_PROVIDER.CONTA_AZUL;
    const isNfseActive = this.state.nfeIntegrationActive;
    const isNfseStep1Done = this.state.nfeStep1Done;
    const areNfseCredentialsLocked = isNfseStep1Done || isNfseActive;
    const hasNfseClientId = Boolean((this.state.nfeClientId || "").trim());
    const hasNfseClientSecret = Boolean(
      (this.state.nfeClientSecret || "").trim(),
    );
    const canStartNfseAuthentication =
      !isNfseStep1Done &&
      !isNfseActive &&
      hasNfseClientId &&
      hasNfseClientSecret;
    const canUseNfsePrimaryAction = isNfseStep1Done
      ? !isNfseActive
      : canStartNfseAuthentication;
    const nfsePrimaryActionText = isNfseStep1Done
      ? freire(texts.NFSE_STEP2_COMPLETE)
      : freire(texts.NFSE_STEP1_AUTHENTICATE);
    let nfseStatusText;
    if (isNfseActive) {
      nfseStatusText = freire(texts.NFSE_STATUS_COMPLETED_ACTIVE);
    } else if (isNfseStep1Done) {
      nfseStatusText = freire(texts.NFSE_STATUS_AUTHENTICATED_PENDING);
    } else {
      nfseStatusText = freire(texts.NFSE_STATUS_PENDING_CONFIGURATION);
    }

    // NFS-e settings are persisted when clicking the main Save button at bottom

    return (
      <div className="container">
        <Breadcrumbs
          breadcrumbs={[
            freire(texts.ADMIN),
            freire(texts.MANAGEMENT),
            freire(texts.COMPANIES),
          ]}
        />
        <div className="filter">
          <Form wrapperCol={{ span: 24 }}>
            <Form.Item>
              <div style={{ flexDirection: "row", display: "flex" }}>
                {getFieldDecorator("companyName")(
                  <Input
                    className="firstInput"
                    placeholder={freire(texts.SEARCH_BY_COMPANY)}
                    onKeyPress={this.handleKeyPress}
                  />,
                )}
                <Button
                  icon="search"
                  className="buttonSearch"
                  onClick={this.filter}
                >
                  {freire(texts.SEARCH)}
                </Button>
                <Show when={"add-company"}>
                  <Button
                    icon="plus"
                    className="buttonNew"
                    onClick={this.goNew}
                    type="primary"
                  >
                    {freire(texts.NEW)}
                  </Button>
                </Show>
              </div>
            </Form.Item>
            <SelectCountry
              form={this.props.form}
              isRequired={false}
              disabled={loadingFetchData}
              loading={loadingFetchData}
              countries={countries}
              showWarn={false}
            />
            <Show when={"view-draft-companies"}>
              <Form.Item
                label={freire(texts.ONLY_DRAFTS_LABEL)}
                style={{ marginBottom: 0 }}
              >
                <Switch
                  checked={this.state.onlyDrafts}
                  onChange={this.onToggleDrafts}
                  checkedChildren={freire(texts.ONLY_DRAFTS_ON)}
                  unCheckedChildren={freire(texts.ONLY_DRAFTS_OFF)}
                />
              </Form.Item>
            </Show>
          </Form>

          <div className="footer">
            <Button style={{ marginRight: 10 }} onClick={this.clearFilters}>
              {freire(texts.CLEAN)}
            </Button>
            <Button onClick={this.filter} type="primary">
              {freire(texts.FILTER)}
            </Button>
          </div>
        </div>

        <Table
          style={{ backgroundColor: "white" }}
          loading={this.state.loadingTable}
          rowKey={(data) => data._id}
          dataSource={this.state.dateFiltrada}
          columns={columns}
          pagination={{
            current: this.state.tablePage,
            onChange: (page) => this.setState({ tablePage: page }),
          }}
        />

        <Drawer
          title={freire(texts.EDIT_COMPANY)}
          width={700}
          onClose={this.closeDrawer}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          destroyOnClose
        >
          <span className="titleNewCompanyEdt">{freire(texts.INFO)}</span>
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item label={freire(texts.NAME)}>
                  <Input
                    placeholder={freire(texts.NAME)}
                    value={this.state.company.companyName}
                    onChange={(value) => {
                      let company = this.state.company;
                      company.companyName = value.target.value;
                      this.setState({ company });
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* NFS-e Settings */}
            {showNfseProviderConfig && (
              <Show when={"edit-company-nfse-provider"}>
                <Fragment>
                  <span className="titleNewCompanyEdt">
                    {freire(texts.NFSE_SECTION)}
                  </span>
                  <Row gutter={[16, 0]}>
                    <Col span={18}>
                      <Form.Item>
                        <div className="nfseEmitRow">
                          <span className="nfseEmitSubtitle">
                            {freire(texts.NFSE_EMIT)}
                          </span>
                          <Switch
                            className="nfseSwitch"
                            checkedChildren={freire(texts.YES)}
                            unCheckedChildren={freire(texts.NO)}
                            checked={this.state.nfeEnabled}
                            onChange={(checked) => {
                              if (checked) {
                                this.setState({
                                  nfeEnabled: true,
                                  nfeProvider: "",
                                  nfeClientId: "",
                                  nfeClientSecret: "",
                                  nfeStep1Done: false,
                                  nfeIntegrationActive: false,
                                });
                              } else {
                                this.setState({
                                  nfeEnabled: false,
                                  nfeProvider: "",
                                  nfeClientId: "",
                                  nfeClientSecret: "",
                                  nfeStep1Done: false,
                                  nfeIntegrationActive: false,
                                  nfeInfoModalVisible: false,
                                });
                              }
                            }}
                          />
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>

                  {this.state.nfeEnabled && (
                    <Row gutter={[16, 0]}>
                      <Col span={12}>
                        <Form.Item label={freire(texts.NFSE_PROVIDER)}>
                          <Select
                            value={this.state.nfeProvider || undefined}
                            placeholder={freire(texts.SELECT)}
                            onChange={(value) =>
                              this.setState({
                                nfeProvider: value || "",
                                nfeClientId: "",
                                nfeClientSecret: "",
                                nfeStep1Done: false,
                                nfeIntegrationActive: false,
                              })
                            }
                            disabled={!this.state.nfeEnabled}
                          >
                            <Option value="">{freire(texts.SELECT)}</Option>
                            <Option value={NFE_PROVIDER.CONTA_AZUL}>
                              Conta Azul
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  )}

                  {isContaAzulSelected && (
                    <>
                      <Row gutter={[16, 0]}>
                        <Col span={24}>
                          <Alert
                            style={{ marginTop: 8, marginBottom: 8 }}
                            type="info"
                            showIcon
                            message={freire(
                              texts.CONTA_AZUL_REDIRECT_URL_TITLE,
                            )}
                            description={
                              <span>
                                {freire(
                                  texts.CONTA_AZUL_REDIRECT_URL_DESC_PREFIX,
                                )}{" "}
                                <Tooltip
                                  placement="right"
                                  title={freire(texts.COPY)}
                                >
                                  <Button
                                    type="link"
                                    onClick={() => {
                                      copy(
                                        appEnv.REACT_APP_CONTA_AZUL_REDIRECT_URI ||
                                          " ",
                                      );
                                      message.info(freire(texts.COPIED));
                                    }}
                                    style={{
                                      padding: 0,
                                      height: "auto",
                                      textDecoration: "underline",
                                      color: "#5c00f0",
                                    }}
                                  >
                                    {freire(texts.CLICK_HERE)}
                                  </Button>
                                </Tooltip>{" "}
                                {freire(
                                  texts.CONTA_AZUL_REDIRECT_URL_DESC_SUFFIX,
                                )}
                              </span>
                            }
                          />
                        </Col>
                        <Col span={24}>
                          <div
                            className={`nfseStatusBar ${
                              isNfseActive ? "isActive" : "isPending"
                            }`}
                          >
                            <div className="nfseStatusInfo">
                              <Icon
                                type={
                                  isNfseActive ? "check-circle" : "info-circle"
                                }
                                className="nfseStatusIcon"
                              />
                              <span className="nfseStatusLabel">
                                {freire(texts.NFSE_STATUS_LABEL)}
                              </span>
                              <span className="nfseStatusText">
                                {nfseStatusText}
                              </span>
                            </div>

                            {(isNfseStep1Done || isNfseActive) && (
                              <Button
                                icon="delete"
                                className="nfseRemoveButton"
                                onClick={
                                  isNfseActive
                                    ? this.onRemoveNfseIntegration
                                    : this.onUndoNfseStep1
                                }
                              >
                                {isNfseActive
                                  ? freire(texts.NFSE_REMOVE_INTEGRATION)
                                  : freire(texts.NFSE_REMOVE)}
                              </Button>
                            )}
                          </div>
                        </Col>
                      </Row>

                      {!isNfseActive && (
                        <>
                          <Row gutter={[16, 0]}>
                            <Col span={12}>
                              <Form.Item label={freire(texts.NFSE_CLIENT_ID)}>
                                <Input
                                  id="nfse-client-id"
                                  className="nfseCredentialInput"
                                  value={this.state.nfeClientId}
                                  onChange={(e) =>
                                    this.setState({
                                      nfeClientId: e.target.value,
                                    })
                                  }
                                  placeholder="Ex.: cid_..."
                                  disabled={areNfseCredentialsLocked}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label={freire(texts.NFSE_CLIENT_SECRET)}
                              >
                                <Input.Password
                                  id="nfse-client-secret"
                                  className="nfseCredentialInput"
                                  value={this.state.nfeClientSecret}
                                  onChange={(e) =>
                                    this.setState({
                                      nfeClientSecret: e.target.value,
                                    })
                                  }
                                  placeholder="••••••••"
                                  disabled={areNfseCredentialsLocked}
                                />
                              </Form.Item>
                            </Col>
                          </Row>

                          <Row gutter={[16, 0]}>
                            <Col span={24}>
                              <div className="nfseActionStack">
                                <Button
                                  className="nfsePrimaryActionButton"
                                  loading={
                                    isNfseStep1Done
                                      ? this.state.nfeFinalizeLoading
                                      : false
                                  }
                                  disabled={!canUseNfsePrimaryAction}
                                  onClick={
                                    isNfseStep1Done
                                      ? this.onFinalizeNfseIntegration
                                      : this.onStartNfseAuthentication
                                  }
                                >
                                  {nfsePrimaryActionText}
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </>
                  )}

                  <Modal
                    title={freire(texts.NFSE_AUTH_INFO_TITLE)}
                    visible={this.state.nfeInfoModalVisible}
                    onCancel={() =>
                      this.setState({ nfeInfoModalVisible: false })
                    }
                    footer={[
                      <Button
                        key="cancel"
                        onClick={() =>
                          this.setState({ nfeInfoModalVisible: false })
                        }
                      >
                        {freire(texts.CANCEL)}
                      </Button>,
                      <Button
                        key="continue"
                        type="primary"
                        loading={this.state.nfeAuthLoading}
                        onClick={this.onContinueNfseAuthProcess}
                      >
                        {freire(texts.NFSE_AUTH_INFO_CONTINUE)}
                      </Button>,
                    ]}
                  >
                    <p>{freire(texts.NFSE_AUTH_INFO_TEXT)}</p>
                  </Modal>
                </Fragment>
              </Show>
            )}

            <Row gutter={[16, 0]}>
              <Col span={9}>
                <Form.Item label={freire(texts.SELECT_DOCUMENT_TYPE)} required>
                  <Select
                    placeholder={freire(texts.SELECT_DOCUMENT_TYPE)}
                    value={this.state.company.document_type}
                    onChange={(value) => {
                      let company = this.state.company;
                      company.document_type = value;
                      company.document = formatDocumentByType(
                        company.document,
                        value,
                      );
                      this.setState({ company });
                    }}
                  >
                    {Object.values(DOCUMENT_TYPES).map((value) => (
                      <Option key={value} value={value}>
                        {value}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={15}>
                <Form.Item
                  label={freire(texts.COMPANY_DOCUMENT)}
                  required={!isDocumentOptional}
                >
                  <Input
                    value={this.state.company.document || ""}
                    onChange={(value) => {
                      let company = this.state.company;
                      company.document = formatDocumentByType(
                        value.target.value,
                        this.state.company.document_type,
                      );
                      this.setState({ company });
                    }}
                    placeholder={"Ex.: 12.345.678/0009-10"}
                  />
                </Form.Item>
              </Col>
            </Row>
            {company?.holding && (
              <Show when={"create-parent-company"}>
                <Row gutter={[16, 0]}>
                  <Col span={8}>
                    <Form.Item label={freire(texts.HAS_PARTNERSHIP)}>
                      <Switch
                        checkedChildren={freire(texts.YES)}
                        unCheckedChildren={freire(texts.NO)}
                        checked={hasParentCompanyPartner}
                        onChange={(checked) => {
                          this.setState(({ company }) => ({
                            hasParentCompanyPartner: checked,
                            company: {
                              ...company,
                              parent_company_partners: [],
                            },
                          }));
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={16}>
                    <Form.Item
                      required={hasParentCompanyPartner}
                      label={freire(texts.PARENT_COMPANY_PARTNER)}
                    >
                      <Select
                        placeholder={freire(
                          texts.SELECT_PARENT_COMPANY_PARTNER,
                        )}
                        value={company?.parent_company_partners}
                        mode="multiple"
                        disabled={
                          loadingFetchData ||
                          loadingSave ||
                          !hasParentCompanyPartner
                        }
                        loading={loadingFetchData}
                        showSearch
                        optionFilterProp="children"
                        onChange={(value) => {
                          this.setState(({ company }) => ({
                            company: {
                              ...company,
                              parent_company_partners: value,
                            },
                          }));
                        }}
                      >
                        {companiesHolding.map((company) => (
                          <Option key={company._id} value={company._id}>
                            {company.companyName}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Show>
            )}
            {this.state.company._id !== BRAND_ID &&
              !company?.holding &&
              companiesHolding.length > 0 && (
                <Show when={"edit-parent-company"}>
                  <Row gutter={16}>
                    <Col span={24}>
                      <Form.Item label={freire(texts.PARENT_COMPANY)}>
                        <Select
                          disabled={
                            loadingSave ||
                            !userCompany?.holding ||
                            companiesHolding.length === 1
                          }
                          placeholder={freire(texts.SELECT_PARENT_COMPANY)}
                          showSearch
                          optionFilterProp="children"
                          value={this.state.company.parentCompanyID}
                          onChange={this.onChangeParentCompany}
                        >
                          {companiesHolding.map((company) => (
                            <Option key={company._id} value={company._id}>
                              {company.companyName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </Show>
              )}
            <Show when={"developer"}>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label={freire(texts.OCPI_PARTY_ID)}>
                    <Input
                      placeholder={freire(texts.ADD)}
                      value={this.state.company.ocpiPartyId}
                      onChange={(value) => {
                        let company = this.state.company;
                        company.ocpiPartyId = value.target.value;
                        this.setState({ company });
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Show>
            <Row gutter={[16, 0]}>
              <Col span={10}>
                <SelectCountry
                  disabled={true}
                  initialValue={this.state.company?.country ?? "----"}
                  loading={loadingFetchData}
                  countries={countries}
                  showWarn={false}
                />
              </Col>
              <Col span={14}>
                <Form.Item label={freire(texts.TYPE_OF_COSTUMER)}>
                  <SelectWithNewItem
                    value={this.state.company?.customerType ?? undefined}
                    onChange={(customerType) => {
                      this.setState((state) => ({
                        company: { ...state.company, customerType },
                      }));
                    }}
                    onAddNewItem={this.onAddNewCustomerType}
                    placeholder={freire(texts.PLACEHOLDER_TYPE_OF_COSTUMER)}
                  >
                    {customerTypes.map((customerType) => (
                      <Option key={customerType.name} value={customerType.name}>
                        {customerType.name}
                      </Option>
                    ))}
                  </SelectWithNewItem>
                </Form.Item>
              </Col>
            </Row>

            {isTupiUser && (
              <Row gutter={[16, 0]}>
                <Col span={10}>
                  <Form.Item label={freire(texts.FISCAL_MODEL)}>
                    {company?.fiscal_model === SOFTWARE_LICENSE ? (
                      <Tooltip
                        title={freire(texts.SOFTWARE_LICENSE_MUTED_HINT)}
                      >
                        <span style={{ display: "block" }}>
                          <Select
                            allowClear
                            placeholder={freire(texts.PLACEHOLDER_FISCAL_MODEL)}
                            value={company?.fiscal_model ?? undefined}
                            disabled
                            onChange={(value) =>
                              this.setState(({ company }) => ({
                                company: {
                                  ...company,
                                  fiscal_model: value || null,
                                },
                              }))
                            }
                          >
                            {FISCAL_MODEL_OPTIONS.map((option) => (
                              <Option key={option.value} value={option.value}>
                                {option.label}
                              </Option>
                            ))}
                          </Select>
                        </span>
                      </Tooltip>
                    ) : (
                      <Select
                        allowClear
                        placeholder={freire(texts.PLACEHOLDER_FISCAL_MODEL)}
                        value={company?.fiscal_model ?? undefined}
                        onChange={(value) =>
                          this.setState(({ company }) => ({
                            company: {
                              ...company,
                              fiscal_model: value || null,
                            },
                          }))
                        }
                      >
                        {FISCAL_MODEL_OPTIONS.map((option) => {
                          const isMutedOption =
                            company?.fiscal_model !== SOFTWARE_LICENSE &&
                            option.value === SOFTWARE_LICENSE;
                          return (
                            <Option
                              key={option.value}
                              value={option.value}
                              disabled={isMutedOption}
                            >
                              {isMutedOption ? (
                                <Tooltip
                                  title={freire(
                                    texts.SOFTWARE_LICENSE_MUTED_HINT,
                                  )}
                                >
                                  <span>{option.label}</span>
                                </Tooltip>
                              ) : (
                                option.label
                              )}
                            </Option>
                          );
                        })}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Row gutter={[16, 0]} style={{ marginTop: 8 }}>
              <Col span={24}>
                <Form.Item
                  label=""
                  extra={
                    <span>
                      {this.state.company.idleFeeFirstForgivenessInherited && (
                        <span>
                          {freire(texts.IDLE_FEE_FIRST_FORGIVENESS_INHERITED)}
                          <br />
                        </span>
                      )}
                      {freire(texts.IDLE_FEE_FIRST_FORGIVENESS_DESCRIPTION)}
                    </span>
                  }
                >
                  <Switch
                    checkedChildren={freire(texts.YES)}
                    unCheckedChildren={freire(texts.NO)}
                    checked={
                      this.state.company.idleFeeFirstForgivenessEnabled ?? false
                    }
                    disabled={
                      this.state.company.idleFeeFirstForgivenessInherited ??
                      false
                    }
                    onChange={(value) => {
                      this.setState(({ company }) => ({
                        company: {
                          ...company,
                          idleFeeFirstForgivenessEnabled: value,
                        },
                      }));
                    }}
                  />
                  <span style={{ marginLeft: 10 }}>
                    {freire(texts.IDLE_FEE_FIRST_FORGIVENESS_LABEL)}
                  </span>
                </Form.Item>
              </Col>
            </Row>

            <ShowFeatureFlag
              flag={FEATURE_FLAGS.WEB_FLOW_EDIT}
              orWhen={"developer"}
            >
              <CompanyWebFlowBatch
                company={company}
                allCompanies={this.state.data}
              />
            </ShowFeatureFlag>

            {(canSetHasCompanyPin ||
              canEditCompanyPin ||
              canEditCompanyAllowedApps ||
              canEditCompanyPowerBiUrl ||
              canEditCompanyCustomTheme) && (
              <span className="titleNewCompanyEdt">
                {freire(texts.CUSTOMIZATION)}
              </span>
            )}

            <AlertParentCompanyIconPack
              visible={canSetHasCompanyPin && !canEditCompanyPin}
              parentCompany={parentCompany}
              parentCompanyIconPack={parentCompanyIconPack}
              colSpan={24}
            />

            <Row gutter={[16, 0]} style={{ marginTop: 8 }}>
              {canSetHasCompanyPin && (
                <Col span={8}>
                  <Form.Item label={freire(texts.PINS_CUSTOMIZED)}>
                    <Switch
                      checkedChildren={freire(texts.YES)}
                      unCheckedChildren={freire(texts.NO)}
                      onChange={this.onChangeHasIconPack}
                      checked={hasIconPack}
                      disabled={
                        loadingFetchData || availableIconPacks.length === 0
                      }
                    />
                  </Form.Item>
                </Col>
              )}

              {canEditCompanyPin && (
                <Col span={16}>
                  <Form.Item label={freire(texts.CHOOSE_PIN)}>
                    <Select
                      loading={loadingFetchData}
                      disabled={
                        loadingFetchData ||
                        !hasIconPack ||
                        availableIconPacks.length === 0
                      }
                      placeholder={freire(texts.SELECT)}
                      showSearch
                      value={this.state.company.iconPack}
                      onChange={(iconPack) =>
                        this.setState((state) => ({
                          company: { ...state.company, iconPack },
                        }))
                      }
                    >
                      {availableIconPacks.map((iconPack) => (
                        <Select.Option
                          key={iconPack.alias}
                          value={iconPack.alias}
                        >
                          {iconPack.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
            </Row>

            {canEditCompanyCustomTheme && (
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label={freire(texts.CPMS_CUSTOM_THEME)}>
                    <Select
                      allowClear
                      showSearch
                      loading={loadingFetchData}
                      disabled={loadingFetchData || customThemes.length === 0}
                      placeholder={freire(texts.SELECT_CPMS_CUSTOM_THEME)}
                      optionFilterProp="children"
                      value={this.state.company?.cpms_custom_theme ?? undefined}
                      onChange={(cpms_custom_theme) =>
                        this.setState((state) => ({
                          company: {
                            ...state.company,
                            cpms_custom_theme: cpms_custom_theme || null,
                          },
                        }))
                      }
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {customThemes.map((theme) => (
                        <Select.Option key={theme._id} value={theme._id}>
                          {theme.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}

            {canEditCompanyPowerBiUrl && (
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label={freire(texts.URL_POWERBI)}>
                    <Input
                      placeholder={freire(texts.URL_POWERBI)}
                      value={this.state.company.powerbi}
                      onChange={(value) => {
                        let company = this.state.company;
                        company.powerbi = value.target.value;
                        this.setState({ company });
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}

            {canEditCompanyWhiteLabel && (
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label={freire(texts.WHITE_LABEL)}>
                    <Select
                      allowClear
                      showSearch
                      loading={loadingFetchData}
                      disabled={
                        loadingFetchData || whiteLabelsWithoutBrand.length === 0
                      }
                      placeholder={freire(texts.SELECT_WHITELABEL)}
                      optionFilterProp="children"
                      value={this.state.company?.whiteLabelAlias ?? undefined}
                      onChange={(whiteLabelAlias) => {
                        this.setState((state) => ({
                          company: { ...state.company, whiteLabelAlias },
                        }));
                      }}
                    >
                      {whiteLabelsWithoutBrand.map(({ alias, name }) => (
                        <Select.Option key={alias} value={alias}>
                          {name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}

            {canEditCompanyAllowedApps && (
              <Row gutter={16}>
                <Col span={24}>
                  <AllowedAppsForm
                    form={this.props.form}
                    initialValue={company?.allowed_apps ?? []}
                    loading={loadingFetchData}
                    isHolding={company?.holding}
                    parentCompany={parentCompany}
                  />
                </Col>
              </Row>
            )}

            <Show when={"edit-company-split"}>
              <Row>
                <Col span={12}>
                  <Form.Item label={freire(texts.PAYMENT_SPLIT_RULE)}>
                    <Switch
                      checkedChildren={freire(texts.YES)}
                      unCheckedChildren={freire(texts.NO)}
                      onChange={(value) => {
                        let company = this.state.company;
                        company.hasSplit = value;

                        this.setState({ company });
                      }}
                      checked={this.state.company.hasSplit}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col>
                  {this.state.company.hasSplit ? (
                    <>
                      <Table
                        dataSource={this.state.company.splitRule}
                        columns={columnsSplit}
                        pagination={false}
                      />
                      <Row>
                        <Button
                          style={{ marginRight: 8 }}
                          onClick={() => this.putCompany()}
                        >
                          {freire(texts.SAVE)}
                        </Button>
                        <Button style={{ marginRight: 8 }}>
                          {freire(texts.TOTAL)}{" "}
                          {this.state.company.splitRule.length > 0
                            ? this.state.company.splitRule.reduce(
                                (total, rule) =>
                                  parseInt(total) + parseInt(rule.percentage),
                                0,
                              )
                            : 0}{" "}
                          %
                        </Button>
                        <Select
                          showSearch
                          style={{ width: 200 }}
                          placeholder={freire(texts.SELECT_RECIPIENT)}
                          optionFilterProp="children"
                          onChange={this.onSelect}
                          onSearch={this.onSearch}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {this.state.recipients.map((item) => {
                            return (
                              <Option value={item._id} key={item.recipient_id}>
                                {item.recipientName}
                              </Option>
                            );
                          })}
                        </Select>
                        <Button
                          style={{ marginRight: 8 }}
                          onClick={() => this.addRecebedor()}
                        >
                          {freire(texts.ADD_MORE)}
                        </Button>
                      </Row>
                    </>
                  ) : null}
                </Col>
              </Row>
            </Show>
          </Form>
          <Row gutter={[16, 0]} style={{ marginTop: "30px" }}>
            <Col span={24}>
              <Form wrapperCol={{ span: 24 }}>
                <p className="titleNewCompanyEdt">{freire(texts.REPORT)}</p>
                <Form.Item label={freire(texts.EMAIL_LIST)}>
                  <p className="titleForSelectModalEdit">
                    {freire(texts.EMAIL_REPORT_INFO)}
                    <span
                      role="button"
                      tabIndex={0}
                      style={{ cursor: "pointer", margin: "3px" }}
                      onClick={this.showModal1}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.showModal1();
                        }
                      }}
                      onTouchStart={(e) => {
                        e.preventDefault();
                        this.showModal1();
                      }}
                      aria-label="Exemplo de relatório de estações"
                    >
                      <strong>({freire(texts.EXAMPLE)})</strong>
                    </span>
                    <Modal
                      visible={this.state.showModal1}
                      onCancel={this.handleCancel1}
                      footer={null}
                      maskClosable={true}
                    >
                      <img src={stationReportImg} alt="Station Report" />
                    </Modal>
                    {freire(texts.EMAIL_REPORT_INFO_TWO)}
                    <span
                      role="button"
                      tabIndex={0}
                      style={{ cursor: "pointer", margin: "3px" }}
                      onClick={this.showModal2}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.showModal2();
                        }
                      }}
                      onTouchStart={(e) => {
                        e.preventDefault();
                        this.showModal2();
                      }}
                      aria-label="Exemplo de relatório mensal de cupons"
                    >
                      <strong>({freire(texts.EXAMPLE)})</strong>
                    </span>
                    <Modal
                      visible={this.state.showModal2}
                      onCancel={this.handleCancel2}
                      footer={null}
                      maskClosable={true}
                    >
                      <img src={MonthlyCouponReport} alt="Monthly Coupon" />
                    </Modal>
                    {freire(texts.EMAIL_REPORT_INFO_THREE)}
                    <span
                      role="button"
                      tabIndex={0}
                      style={{ cursor: "pointer", margin: "3px" }}
                      onClick={this.showModal3}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.showModal3();
                        }
                      }}
                      onTouchStart={(e) => {
                        e.preventDefault();
                        this.showModal3();
                      }}
                      aria-label="Exemplo de relatório de consumo da cota"
                    >
                      <strong>({freire(texts.EXAMPLE)})</strong>
                    </span>
                    <Modal
                      visible={this.state.showModal3}
                      onCancel={this.handleCancel3}
                      footer={null}
                      maskClosable={true}
                    >
                      <img src={quotaReportImg} alt="Quota Report" />
                    </Modal>
                  </p>

                  {getFieldDecorator("emails", {
                    initialValue: this.state.emails,
                  })(
                    <Select
                      mode="tags"
                      disabled={loading}
                      style={{ width: "100%" }}
                      placeholder={freire(texts.INPUT_EMAILS)}
                      onSelect={(value) => {
                        if (!isValidEmail(value)) {
                          message.error(freire(texts.INFORM_VALID_EMAIL));
                        } else {
                          this.setState((prevState) => ({
                            emails: [...prevState.emails, value],
                          }));
                        }
                      }}
                      onDeselect={(value) => {
                        this.setState((prevState) => ({
                          emails: prevState.emails.filter(
                            (email) => email !== value,
                          ),
                        }));
                      }}
                    />,
                  )}
                </Form.Item>
              </Form>
            </Col>
          </Row>
          <div
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              width: "100%",
              borderTop: "1px solid #e9e9e9",
              padding: "10px 16px",
              background: "#fff",
              textAlign: "right",
            }}
          >
            <Button onClick={this.closeDrawer} style={{ marginRight: 8 }}>
              {freire(texts.CANCEL)}
            </Button>
            <Button
              loading={loadingSave}
              onClick={() => this.save()}
              type="primary"
            >
              {freire(texts.SAVE)}
            </Button>
          </div>
        </Drawer>
      </div>
    );
  }
}

const ListCompaniesWithWhitelabels = (props) => {
  const { availableIconPacks, allWhitelabels } = useWhitelabels();
  return (
    <ListCompanies
      {...props}
      availableIconPacks={availableIconPacks}
      allWhitelabels={allWhitelabels}
    />
  );
};

const PageListCompanies = Form.create({
  name: "list_companies_form",
  mapPropsToFields(props) {
    return {
      loading: Form.createFormField({
        value: props.loading,
      }),
    };
  },
})(ListCompaniesWithWhitelabels);

export default withPermission(PageListCompanies);
